import { z } from "zod";

export const addPatientSchema = z.object({
  name: z
    .string({
      required_error: "Name is required",
    })
    .min(3, {
      message: "Name must be at least 3 characters long",
    }),
  age: z
    .string({
      required_error: "Age is required",
    })
    .optional(),
  dob: z
    .date({
      required_error: "Date of birth is required",
    })
    .optional(),
  gender: z.string({
    required_error: "Gender is required",
  }),
  height: z.string().optional(),
  weight: z.string().optional(),
  allergies: z.string().optional(),
  pastIllness: z.string().optional(),
});

export type AddPatientSchema = z.infer<typeof addPatientSchema>;
